<div class="content-wrapper table-full-bx details-page">
    <div class="page-content">
        <div class="row">
            <div class="col-lg-12">
                <div class="ibox">
                    <div class="ibox-body">
                        <div class="page-heading">
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item"> <a routerLink="/users"> Users </a> </li>
                                <li class="breadcrumb-item"> User Detail </li>
                            </ol>
                        </div>

                        <div class="repeatedrow">
                            <h4> User Detail  <a [routerLink]="'/users/edit/' + usersData?.id" class="editBtn"> <img src="assets/images/ic_edit.svg"> Edit </a></h4>
                            <div class="rowbody">
                                <div class="listview">
                                    <dl class="list">
                                        <dt>Full Name </dt>
                                        <dt>{{usersData?.fullName || "--"}} </dt>
                                    </dl>
                                    <dl class="list">
                                        <dt>Email </dt>
                                        <dt>{{usersData?.email || "--"}} </dt>
                                    </dl>
                                    <dl class="list">
                                        <dt>Phone Number </dt>
                                        <dt>{{usersData?.phoneNumber | mask:'0000-000-000'}} </dt>
                                    </dl>
                                    <dl class="list">
                                        <dt>LinkedIn </dt>
                                        <dt><a href="{{usersData?.linkedin}}" target="_blank" class="text-orange">{{usersData?.linkedin || "--"}}</a> </dt>
                                    </dl>
                                    <dl class="list">
                                        <dt>Title </dt>
                                        <dt>{{usersData?.title || "--"}} </dt>
                                    </dl>
                                    <dl class="list">
                                        <dt>Last Activity </dt>
                                        <dt>{{usersData?.lastActivity | date: "d/M/YYYY h:mm a"}} </dt>
                                    </dl>
                                    <dl class="list">
                                        <dt>Assign a Group </dt>
                                        <dt>
                                            <span class="group" *ngFor="let group of usersData?.assign_user_groups; let isLast=last">
                                                {{group?.group_permission?.groupName}} {{ isLast ? "" : ", " }}
                                            </span>
                                        </dt>
                                    </dl>
                                </div>
                            </div>
                        </div>

                        <div class="permissionsBox pt-5">
                            <h3> Permissions </h3>
                            <ul>
                                <li *ngFor="let data of accessData;let i=index">
                                    <div *ngFor="let data1 of data; let j=index">
                                        <span *ngIf="j==0">{{data1?.name}} </span>
                                        <strong>{{data1?.title}} </strong>
                                    </div>
                                </li>
                            </ul>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>